var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "w-100 h-100 d-flex flex-column align-items-center justify-content-between pt-3 pb-2 vue-uploadbox-inner-container",
      on: {
        click: function ($event) {
          $event.stopPropagation()
          $event.preventDefault()
          return _vm.openFileUploadDialog($event)
        },
        dragover: function ($event) {
          return _vm.handleDragAndDrop(true)
        },
        dragleave: function ($event) {
          return _vm.handleDragAndDrop(false)
        },
        drop: function ($event) {
          _vm.dragOver = false
        },
      },
    },
    [
      _c(
        "div",
        {
          staticClass:
            "w-100 h-100 d-flex flex-column justify-content-center align-items-center",
        },
        [
          _vm.viewToRender === "default"
            ? _c("file-upload-default-view", {
                attrs: {
                  "disable-g-drive-button": _vm.disableGdriveButton,
                  showDropdown: _vm.showDropdown,
                  "start-clicked": _vm.startClicked,
                },
                on: {
                  "open-file-upload-dialog": function ($event) {
                    return _vm.openFileUploadDialog($event)
                  },
                  "open-g-drive-dialog": _vm.openGdriveDialog,
                  "open-drop-box-dialog": _vm.openDropboxDialog,
                  "copy-from-clipboard": function ($event) {
                    return _vm.copyFromClipboard($event)
                  },
                  "toggle-drop-down": _vm.toggleDropdown,
                  startClicked: function ($event) {
                    _vm.startClicked = true
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.viewToRender === "drag-and-drop"
            ? _c("drag-and-drop-view", {
                attrs: {
                  "disable-g-drive-button": _vm.disableGdriveButton,
                  showDropdown: _vm.showDropdown,
                  "start-clicked": _vm.startClicked,
                },
                on: {
                  "open-file-upload-dialog": function ($event) {
                    return _vm.openFileUploadDialog($event)
                  },
                  "open-g-drive-dialog": _vm.openGdriveDialog,
                  "open-drop-box-dialog": _vm.openDropboxDialog,
                  "toggle-drop-down": _vm.toggleDropdown,
                  startClicked: function ($event) {
                    _vm.startClicked = true
                  },
                  isDragOver: (status) => (_vm.dragOverInner = status),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.viewToRender === "upload-in-progress"
            ? _c("upload-in-progress-view", {
                attrs: {
                  "disable-g-drive-button": _vm.disableGdriveButton,
                  showDropdown: _vm.showDropdown,
                  "start-clicked": _vm.startClicked,
                  "show-submit-btn": _vm.showSubmitBtn,
                  "is-single-file": this.isSingleFileFeature,
                  showSettingsBtn: _vm.showSettingsButton,
                },
                on: {
                  "open-file-upload-dialog": function ($event) {
                    return _vm.openFileUploadDialog($event)
                  },
                  "open-g-drive-dialog": _vm.openGdriveDialog,
                  "open-drop-box-dialog": _vm.openDropboxDialog,
                  "toggle-drop-down": _vm.toggleDropdown,
                  startClicked: function ($event) {
                    _vm.startClicked = true
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.viewToRender === "add-file"
            ? _c("add-file-view", {
                attrs: {
                  "disable-g-drive-button": _vm.disableGdriveButton,
                  showDropdown: _vm.showDropdown,
                  "start-clicked": _vm.startClicked,
                },
                on: {
                  "open-file-upload-dialog": function ($event) {
                    return _vm.openFileUploadDialog($event)
                  },
                  "open-g-drive-dialog": _vm.openGdriveDialog,
                  "open-drop-box-dialog": _vm.openDropboxDialog,
                  "copy-from-clipboard": function ($event) {
                    return _vm.copyFromClipboard($event)
                  },
                  "toggle-drop-down": _vm.toggleDropdown,
                  startClicked: function ($event) {
                    _vm.startClicked = true
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.viewToRender === "compare-view"
            ? _c("compare-view", {
                attrs: {
                  "disable-g-drive-button": _vm.disableGdriveButton,
                  showDropdown: _vm.showDropdown,
                  "start-clicked": _vm.startClicked,
                  "files-uploaded": _vm.filesUploaded,
                  showSettingsBtn: _vm.showSettingsButton,
                },
                on: {
                  "open-file-upload-dialog": function ($event) {
                    return _vm.openFileUploadDialog($event)
                  },
                  "open-g-drive-dialog": _vm.openGdriveDialog,
                  "open-drop-box-dialog": _vm.openDropboxDialog,
                  "copy-from-clipboard": function ($event) {
                    return _vm.copyFromClipboard($event)
                  },
                  "toggle-drop-down": _vm.toggleDropdown,
                  startClicked: function ($event) {
                    _vm.startClicked = true
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.viewToRender === "single-file-view"
            ? _c("single-file-view", {
                attrs: {
                  "start-clicked": _vm.startClicked,
                  "files-uploaded": _vm.filesUploaded,
                },
                on: {
                  startClicked: function ($event) {
                    _vm.startClicked = true
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.viewToRender === "file-added"
            ? _c("file-added-view", {
                attrs: {
                  "disable-g-drive-button": _vm.disableGdriveButton,
                  showDropdown: _vm.showDropdown,
                  "start-clicked": _vm.startClicked,
                  "show-submit-btn": _vm.showSubmitBtn,
                  showSettingsBtn: _vm.showSettingsButton,
                },
                on: {
                  "open-file-upload-dialog": function ($event) {
                    return _vm.openFileUploadDialog($event)
                  },
                  "open-g-drive-dialog": _vm.openGdriveDialog,
                  "open-drop-box-dialog": _vm.openDropboxDialog,
                  "copy-from-clipboard": function ($event) {
                    return _vm.copyFromClipboard($event)
                  },
                  "toggle-drop-down": _vm.toggleDropdown,
                  startClicked: function ($event) {
                    _vm.startClicked = true
                  },
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.viewToRender === "waiting-for-upload"
            ? _c("waiting-for-upload-view", { attrs: { files: _vm.files } })
            : _vm._e(),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showDriveLinks
        ? _c(
            "div",
            {
              staticClass:
                "w-100 d-none d-sm-flex justify-content-end align-items-center gap-10 pr-1 uploader-drive-link-container",
            },
            [
              _c("i", {
                staticClass: "fa fa-folder-open lh-inherit",
                attrs: {
                  "data-toggle": "tooltip",
                  "data-trigger": "hover",
                  title: _vm._f("trans")("Device"),
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.openFileUploadDialog($event)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "RouterLink",
                {
                  attrs: {
                    id: "externalUrlButtonOnUploader",
                    to: { name: "remote-url" },
                    title: _vm._f("trans")(
                      "Enter the link of a file you want to use"
                    ),
                    tag: "span",
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "special-class",
                      attrs: {
                        "data-toggle": "tooltip",
                        "data-trigger": "hover",
                        title: _vm._f("trans")("URL"),
                        width: "18",
                        height: "18",
                        viewBox: "0 0 18 18",
                        fill: "none",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                      on: { click: _vm.hideToolTip },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M8.08468 9.91532C8.35084 10.1685 8.35084 10.584 8.08468 10.8371C7.83151 11.0903 7.41605 11.0903 7.16287 10.8371C6.55485 10.2282 6.21335 9.40285 6.21335 8.54234C6.21335 7.68183 6.55485 6.85649 7.16287 6.24756L9.46091 3.94952C10.0698 3.3415 10.8952 3 11.7557 3C12.6162 3 13.4415 3.3415 14.0505 3.94952C14.6585 4.55845 15 5.3838 15 6.24431C15 7.10482 14.6585 7.93016 14.0505 8.5391L13.0832 9.50635C13.0897 8.97403 13.0053 8.44172 12.8236 7.93538L13.1287 7.62378C13.3107 7.44376 13.4551 7.22943 13.5537 6.9932C13.6523 6.75697 13.7031 6.50354 13.7031 6.24756C13.7031 5.99158 13.6523 5.73814 13.5537 5.50191C13.4551 5.26568 13.3107 5.05135 13.1287 4.87133C12.9486 4.68935 12.7343 4.54487 12.4981 4.44627C12.2619 4.34767 12.0084 4.2969 11.7524 4.2969C11.4965 4.2969 11.243 4.34767 11.0068 4.44627C10.7706 4.54487 10.5562 4.68935 10.3762 4.87133L8.08468 7.16287C7.9027 7.34289 7.75822 7.55722 7.65962 7.79345C7.56102 8.02968 7.51025 8.28312 7.51025 8.5391C7.51025 8.79508 7.56102 9.04851 7.65962 9.28474C7.75822 9.52097 7.9027 9.7353 8.08468 9.91532ZM9.91532 7.16287C10.1685 6.9097 10.584 6.9097 10.8371 7.16287C11.4451 7.7718 11.7867 8.59715 11.7867 9.45766C11.7867 10.3182 11.4451 11.1435 10.8371 11.7524L8.5391 14.0505C7.93016 14.6585 7.10482 15 6.24431 15C5.3838 15 4.55845 14.6585 3.94952 14.0505C3.3415 13.4415 3 12.6162 3 11.7557C3 10.8952 3.3415 10.0698 3.94952 9.46091L4.91677 8.49365C4.91028 9.02597 4.99467 9.55828 5.17644 10.0711L4.87133 10.3762C4.68935 10.5562 4.54487 10.7706 4.44627 11.0068C4.34767 11.243 4.2969 11.4965 4.2969 11.7524C4.2969 12.0084 4.34767 12.2619 4.44627 12.4981C4.54487 12.7343 4.68935 12.9486 4.87133 13.1287C5.05135 13.3107 5.26568 13.4551 5.50191 13.5537C5.73814 13.6523 5.99158 13.7031 6.24756 13.7031C6.50354 13.7031 6.75697 13.6523 6.9932 13.5537C7.22943 13.4551 7.44376 13.3107 7.62378 13.1287L9.91532 10.8371C10.0973 10.6571 10.2418 10.4428 10.3404 10.2066C10.439 9.97032 10.4897 9.71689 10.4897 9.46091C10.4897 9.20493 10.439 8.95149 10.3404 8.71526C10.2418 8.47903 10.0973 8.2647 9.91532 8.08468C9.85227 8.0256 9.80201 7.95422 9.76766 7.87494C9.7333 7.79566 9.71557 7.71018 9.71557 7.62378C9.71557 7.53738 9.7333 7.45189 9.76766 7.37261C9.80201 7.29334 9.85227 7.22195 9.91532 7.16287Z",
                          fill: "#E8EAED",
                        },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c("i", {
                staticClass: "fab fa-google-drive",
                class: { "opacity-65": _vm.disableGdriveButton },
                attrs: {
                  "data-toggle": "tooltip",
                  "data-trigger": "hover",
                  title: _vm._f("trans")("Google Drive"),
                },
                on: {
                  click: function ($event) {
                    $event.stopPropagation()
                    $event.preventDefault()
                    return _vm.openGdriveDialog.apply(null, arguments)
                  },
                },
              }),
              _vm._v(" "),
              _c(
                "svg",
                {
                  attrs: {
                    "data-toggle": "tooltip",
                    "data-trigger": "hover",
                    title: _vm._f("trans")("Dropbox"),
                    width: "18",
                    height: "18",
                    viewBox: "0 0 16 16",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.openDropboxDialog.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M4.99975 2.90137L2 4.8125L4.99975 6.72368L7.99998 4.8125L4.99975 2.90137ZM11 2.90137L7.99998 4.81269L11 6.72401L14 4.81269L11 2.90137ZM2 8.63514L4.99975 10.5463L7.99998 8.63514L4.99975 6.72401L2 8.63514ZM11 6.72401L7.99998 8.63533L11 10.5466L14 8.63533L11 6.72401ZM4.99999 11.1875L8.00021 13.0987L11 11.1875L8.00021 9.27634L4.99999 11.1875Z",
                      fill: "#E8EAED",
                    },
                  }),
                ]
              ),
              _vm._v(" "),
              _c(
                "svg",
                {
                  attrs: {
                    "data-toggle": "tooltip",
                    "data-trigger": "hover",
                    title: _vm._f("trans")("Copy From Clipboard"),
                    width: "14",
                    height: "14",
                    viewBox: "0 0 12 12",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg",
                  },
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                      $event.preventDefault()
                      return _vm.copyFromClipboard.apply(null, arguments)
                    },
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      d: "M4.4999 9.6C4.1699 9.6 3.8875 9.4826 3.6527 9.2478C3.4179 9.013 3.3003 8.7304 3.2999 8.4V1.2C3.2999 0.87 3.4175 0.5876 3.6527 0.3528C3.8879 0.118 4.1703 0.0004 4.4999 0H9.8999C10.2299 0 10.5125 0.1176 10.7477 0.3528C10.9829 0.588 11.1003 0.8704 11.0999 1.2V8.4C11.0999 8.73 10.9825 9.0126 10.7477 9.2478C10.5129 9.483 10.2303 9.6004 9.8999 9.6H4.4999ZM4.4999 8.4H9.8999V1.2H4.4999V8.4ZM2.0999 12C1.7699 12 1.4875 11.8826 1.2527 11.6478C1.0179 11.413 0.900302 11.1304 0.899902 10.8V3C0.899902 2.83 0.957502 2.6876 1.0727 2.5728C1.1879 2.458 1.3303 2.4004 1.4999 2.4C1.6699 2.4 1.8125 2.4576 1.9277 2.5728C2.0429 2.688 2.1003 2.8304 2.0999 3V10.8H8.0999C8.2699 10.8 8.4125 10.8576 8.5277 10.9728C8.6429 11.088 8.7003 11.2304 8.6999 11.4C8.6999 11.57 8.6423 11.7126 8.5271 11.8278C8.4119 11.943 8.2695 12.0004 8.0999 12H2.0999Z",
                      fill: "#E8EAED",
                    },
                  }),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }